const $ = jQuery;

export function restoreFocusForSubmenu(menuLI) {
	$(menuLI).children('ul').children('li').children('a,button')
		.each(function () {
			const tabIndex = $(this).is('[data-original-focus]') ? $(this).attr('data-original-focus') : 0;
			$(this).attr('tabindex', tabIndex);
		});
}

export function disableFocusForSubmenu(menuLI) {
	let result = false;
	$(menuLI).children('ul').children('li').children('a,button')
		.each(function () {
			if (!$(this).is('[data-original-focus]')) {
				const focusValue = $(this).is('[tabindex]') ? $(this).attr('tabindex') : 0;
				$(this).attr('data-original-focus', focusValue);
			}
			if (parseInt($(this).attr('tabindex'), 10) >= 0) {
				result = true;
			}
			$(this).attr('tabindex', '-1');
		});
	return result;
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/submenu-tools.js